export const UPLOAD_VISIBLE_CAP = 96

export type VideoBusyPhase = 'preparing' | 'uploading' | 'processing'
export type VideoProcessStep = 'upload' | 'process' | 'ready'
export type VideoProcessStepState = 'done' | 'current' | 'upcoming'

export function visibleUploadPercent(raw: number): number {
  if (!Number.isFinite(raw)) return 0
  return Math.min(UPLOAD_VISIBLE_CAP, Math.max(0, Math.round(raw)))
}

export function videoProcessStepState(
  phase: VideoBusyPhase,
  step: VideoProcessStep,
): VideoProcessStepState {
  if (step === 'ready') return 'upcoming'
  if (phase === 'processing') return step === 'process' ? 'current' : 'done'
  return step === 'upload' ? 'current' : 'upcoming'
}
